import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const RevokeUserIcon = ({ size = 17, ...props }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.07143 0C3.7315 0 1.82143 1.91007 1.82143 4.25C1.82143 5.71321 2.56821 7.01371 3.69993 7.77932C1.53425 8.70825 0 10.8557 0 13.3571H1.21429C1.21429 10.6675 3.38179 8.5 6.07143 8.5C6.90686 8.5 7.68279 8.71736 8.36643 9.08893C7.66733 9.95324 7.28586 11.0312 7.28571 12.1429C7.28571 14.8179 9.46779 17 12.1429 17C14.8179 17 17 14.8179 17 12.1429C17 9.46779 14.8179 7.28571 12.1429 7.28571C11.1198 7.28709 10.1235 7.61226 9.29657 8.21464C9.02821 8.04646 8.738 7.905 8.44293 7.77871C9.02068 7.38895 9.49405 6.86345 9.82154 6.24825C10.149 5.63306 10.3207 4.94694 10.3214 4.25C10.3214 1.91007 8.41136 0 6.07143 0ZM6.07143 1.21429C7.75504 1.21429 9.10714 2.56639 9.10714 4.25C9.10714 5.93361 7.75504 7.28571 6.07143 7.28571C4.38782 7.28571 3.03571 5.93361 3.03571 4.25C3.03571 2.56639 4.38782 1.21429 6.07143 1.21429ZM12.1429 8.5C14.1622 8.5 15.7857 10.1235 15.7857 12.1429C15.7857 14.1622 14.1622 15.7857 12.1429 15.7857C10.1235 15.7857 8.5 14.1622 8.5 12.1429C8.5 10.1235 10.1235 8.5 12.1429 8.5ZM10.835 10.2286L12.1429 11.5364L13.4507 10.2286L14.3214 11.0993L13.0136 12.4071L14.3214 13.7149L13.4507 14.5857L12.1429 13.2779L10.835 14.5857L9.96429 13.7149L11.2721 12.4071L9.96429 11.0993L10.835 10.2286Z"
      fill={props.color || "currentColor"}
    />
  </svg>
);

export default RevokeUserIcon;
